// extracted by mini-css-extract-plugin
export default {"register-page":"Register_register-page__KGLw3","member-btn":"Register_member-btn__8sh7K"};